<div style="margin: 5px; width: 100%; display: flex; flex-direction: column;"    >
  <div style=" color: darkgray;">
    {{this.Division.Name}}
  </div>
  <div style="display: flex; align-items: center;"  >
    <div style="display: flex; width: 100%; ">
      <table >
        <tr>
          <td style="text-align: center; width: 150px">
            <img style="height: 60px;" [src]="'../../assets/img/' + this.Game.Game.HomeTeamSmallIcon"><br/>
            <span>{{this.Game.HomeTeam.team.Name}}</span>
          </td>
          <td style="width: 40%;font-size: large; font-family: Roboto; text-align: center; ">
            @if (this.Game?.Game?.GameTimeUTC!='0001-01-01T00:00:00') {
              <div>
                {{this.Game.Game.GameTimeUTC + 'Z' | date: 'E'}}
                {{this.Game.Game.GameTimeUTC + 'Z' | date: 'dd'}}
                {{this.Game.Game.GameTimeUTC + 'Z' | date: 'LLL'}}
              </div>
            }
            @if (this.Game?.Game?.GameTimeUTC!='0001-01-01T00:00:00') {
              <div style="font-size: large;">
              {{this.Game.Game.GameTimeUTC + 'Z' | date: 'HH:mm'}}</div>
            }
            <br />
            <mat-divider></mat-divider>
            <div style="font-size: medium; font-family: Roboto; text-align: center; margin-bottom: 5px; ">
              {{this.Game.Game.GameDate | date: 'E'}}
              {{this.Game.Game.GameDate | date: 'dd'}}
              {{this.Game.Game.GameDate | date: 'LLL'}}
              {{this.Game.Game.GameTime | date: 'HH:mm'}}<br />
              @if (this.Game.Game.ArenaTimeZoneIANA) {
                <div class="timezone">
                  <mat-icon style="font-size: medium;">public</mat-icon>
                  {{this.Game.Game.ArenaTimeZoneIANA}}
                </div>
              }
            </div>

            <div style="font-size: medium;">

              <mat-divider></mat-divider>
              {{this.Game.Game.Venue}}
            </div>
          </td>
          <td style="text-align: center;width:150px;">
            <img style="height: 80px;" [src]="'../../assets/img/' + this.Game.Game.AwayTeamSmallIcon"><br/>
            <span>{{this.Game.AwayTeam.team.Name}}</span>
          </td>


        </tr>
        <!-- <tr *ngIf="this.Game.GameStatistics" style="border: 1px;">
        <td style="text-align: center; padding-top: 10px; font-weight: bold;">{{this.Game.GameStatistics.GoalsHome}}</td>
        <td  style="text-align: center; padding-top: 10px; font-weight: bold;">
          <label *ngIf="this.Game.GameStatistics.IsFinalScore">

            <label style="font-weight: lighter;">FINAL</label>
          </label>
          <label *ngIf="!this.Game.GameStatistics.IsFinalScore && this.Game.GameStatistics.GameClock">
            <label style="font-weight: lighter;">Game clock</label><br/>
            {{this.Game.GameStatistics.GameClock}}
          </label>
        </td>
        <td style="text-align: center;padding-top: 10px; font-weight: bold;">{{this.Game.GameStatistics.GoalsAway}}</td>
      </tr>
      <tr>
        <td colspan="3">

        </td>
      </tr> -->

    </table>

  </div>


</div>
@if (this.Game?.GameLinks[0]?.SourceId==1) {
  <div style="display: flex; align-items: center; color: gray; ">
    <div style="display: flex; min-width: 500px; ">
      @if (this.isLoadingStats) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
      @if (this.Game?.GameStatistics) {
        <table >
          <tr  style="border: 1px;">
            <td style="text-align: center; width: 150px;padding-top: 10px; font-weight: bold;">
              {{this.Game.GameStatistics.GoalsHome}}
            </td>
            <td  style="text-align: center; padding-top: 10px; font-weight: bold; width: 150px;">
              @if (this.Game.GameStatistics.IsFinalScore) {
                <label style="font-weight: lighter;">
                  FINAL
                </label>
              }
              @if (!this.Game.GameStatistics.IsFinalScore && this.Game.GameStatistics.GameClock) {
                <label style="font-weight: lighter;">
                  Game clock
                </label>
                }<br/>
                @if (!this.Game.GameStatistics.IsFinalScore && this.Game.GameStatistics.GameClock) {
                  <label>
                    {{this.Game.GameStatistics.GameClock}}
                  </label>
                }
                <br/>
                @if (this.Game.GameStatistics.GameClock) {
                  <label class="smallText" >Spectators: {{this.Game.GameStatistics.Spectators}}</label>
                }
              </td>
              <td style="text-align: center;padding-top: 10px; font-weight: bold; width: 150px;">{{this.Game.GameStatistics.GoalsAway}}</td>
              <td>
                <!--   <div *ngIf="this.Game?.GameLinks[0]?.SourceId==1 && !this.isLoadingStats && !this.Game?.GameStatistics?.IsFinalScore">
                <button mat-button color="primary" (click)="importStats(this.Game.Game.GameId)"><mat-icon>add</mat-icon>IMPORT STATS (SWEHOCKEY)</button>
              </div> -->
            </td>
          </tr>
          @if (this.Game.GameStatistics.GameClock) {
            <tr>
              <td class="smallText" style="text-align: center;">{{this.Game.GameStatistics.ShotsHome}}</td>
              <td class="smallText" style="text-align: center;">Shots</td>
              <td class="smallText" style="text-align: center;">{{this.Game.GameStatistics.ShotsAway}}</td>
              <td></td>
            </tr>
          }
          @if (this.Game.GameStatistics.GameClock) {
            <tr>
              <td class="smallText" style="text-align: center;">{{this.Game.GameStatistics.PenaltyTimeHome}}</td>
              <td class="smallText" style="text-align: center;">PIM</td>
              <td class="smallText" style="text-align: center;">{{this.Game.GameStatistics.PenaltyTimeAway}}</td>
              <td></td>
            </tr>
          }
          @if (this.Game.GameStatistics.GameClock) {
            <tr>
              <td class="smallText" style="text-align: center;">{{this.Game.GameStatistics.SavesHome}}</td>
              <td class="smallText" style="text-align: center;">Saves</td>
              <td class="smallText" style="text-align: center;">{{this.Game.GameStatistics.SavesAway}}</td>
              <td></td>
            </tr>
          }
        </table>
      }
      <!--    -->
    </div>
  </div>
}
@if (this.Game?.GameLinks[0]?.SourceId==1 && !this.isLoadingStats && !this.Game?.GameStatistics?.IsFinalScore) {
  <div>
    <button mat-button color="primary" (click)="importStats(this.Game.Game.GameId)"><mat-icon>add</mat-icon>IMPORT STATS (SWEHOCKEY)</button>
  </div>
}

</div>